<div class="shell-wrapper" cdkScrollable #boxBody scrollSpyParent>
  <download-header></download-header>
  <box-header></box-header>
  <breadcrumb></breadcrumb>
  <router-outlet></router-outlet>
  <box-footer></box-footer>
  <box-mobile-nav-footer *ngIf="showMobileNav" class="mobile-nav"></box-mobile-nav-footer>
</div>
